<template>
  <section class="bg-hlt-light text-hlt">
    <div class="container-fluid-lg flex">
      <template v-for="{ key, title, variant, markers } in features" :key>
        <div
          v-if="markers.includes('show-in-test-bar')"
          class="flex justify-center w-full py-3"
        >
          <span>{{ title }}</span>
          <span v-if="variant">, variant {{ variant.name }}</span>
        </div>
      </template>
    </div>
  </section>
</template>

<script setup lang="ts">
const features = useFeatures()
</script>
